import { render, staticRenderFns } from "./nav-dropdown-header.vue?vue&type=template&id=4543927f&"
import script from "./nav-dropdown-header.vue?vue&type=script&lang=ts&"
export * from "./nav-dropdown-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports